import React, { Component } from 'react';
import { get } from 'lodash';
import { Translate, withTranslate } from 'core/translate';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalFooterMessage,
  ModalFooterButtons,
  ModalFooterCancelButton,
  ModalFooterPrimaryButton
} from '../../common/modal/Modal';
import OptionConflictModalContent from './OptionConflictModalContent';

class OptionConflictModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selection: null
    };
  }

  requiresUserSelection = () => {
    const { conflictConfig } = this.props;
    const userSelectionOptions = get(
      conflictConfig,
      'config.TOGGLE_CHECK.userChoiceOptions',
      []
    );
    return userSelectionOptions.length > 0;
  };

  onSelect = () => {
    const { option, onResolve, onSelect } = this.props;
    const { selection } = this.state;

    if (this.requiresUserSelection()) {
      onSelect(selection);
    } else {
      onResolve(option);
    }
  };

  onChange = selection => {
    this.setState({
      selection
    });
  };

  render() {
    const {
      translate,
      option,
      previousConfig,
      conflictConfig,
      hidePrice,
      onClose
    } = this.props;
    const { selection } = this.state;
    const header = translate('configuration.assistant');
    const requiresUserSelection = this.requiresUserSelection();
    return (
      <Modal isOpen={true} contentLabel={header} onRequestClose={onClose}>
        <ModalHeader icon="bell" text={header} onClose={onClose} />
        <ModalBody>
          <div className="modal-body__content">
            <OptionConflictModalContent
              option={option}
              conflictConfig={conflictConfig}
              previousConfig={previousConfig}
              hidePrice={hidePrice}
              selection={selection}
              onChange={this.onChange}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <ModalFooterMessage>
            {requiresUserSelection &&
              !selection && (
                <Translate value="configuration.assistant.continue" />
              )}
          </ModalFooterMessage>
          <ModalFooterButtons>
            <ModalFooterCancelButton onClick={onClose} data-dtm={header} />
            <ModalFooterPrimaryButton
              disabled={requiresUserSelection && !selection}
              onClick={this.onSelect}
              data-dtm={header}>
              <Translate value="byo.page.general.select" />
            </ModalFooterPrimaryButton>
          </ModalFooterButtons>
        </ModalFooter>
      </Modal>
    );
  }
}

export default withTranslate(OptionConflictModal);
